import { render, staticRenderFns } from "./RichTextAreaToolbarButton.vue?vue&type=template&id=6e16f066"
import script from "./RichTextAreaToolbarButton.vue?vue&type=script&lang=js"
export * from "./RichTextAreaToolbarButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports